export default __webpack_public_path__ + "static/video-90652d2021b519815e9a31d4831523c3.mp4";